// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2CoDU","name":"ConsentHeader_name__FaZtX","birthday":"ConsentHeader_birthday__3lamF","skeleton":"ConsentHeader_skeleton__1wSqP"};